import Api from "../api";

export default false
  ? {
      message: "You are Offline. Please! turn on the internet",
    }
  : {
      getMyStore: () => {
        return Api.get(`v1/store/my-store`);
      },
      getStoreMembers: (storeId) => {
        return Api.get(`v1/store/${storeId}/members`);
      },
      addStoreMember: (storeId, payload) => {
        return Api.post(`v1/store/${storeId}/members`, payload);
      },
      updateStoreMember: (storeId, memberId, payload) => {
        return Api.put(`v1/store/${storeId}/members/${memberId}`, payload);
      },
      removeStoreMember: (storeId, memberId) => {
        return Api.delete(`v1/store/${storeId}/members/${memberId}`);
      },
      getStore: (customer_id) => {
        return Api.get(`v1/store/${customer_id}/detail`);
      },
      getStoreBySlug: (slug) => {
        return Api.get(`v1/store/slug/${slug}`);
      },
      getStoreAds: (customer_id, skip, limit) => {
        return Api.get(
          `v1/store/${customer_id}/my-ads?skip=${skip}&limit=${limit}`
        );
      },
      updateStore: (id, payload) => {
        return Api.put(`v1/store/${id}`, payload);
      },
      createStore: (payload) => {
        return Api.post("v1/store", payload);
      },
      createBusinessStore: (payload) => {
        return Api.post("v1/business", payload);
      },
      updateBusinessStore: (id, payload) => {
        return Api.put(`v1/business/${id}`, payload);
      },
      getBusinessStoreBySlug: (slug) => {
        return Api.get(`v1/business/${slug}`);
      },
      getBusinessStore: (customer_id) => {
        return Api.get(`v1/business/${customer_id}/detail`);
      },
      getMyBusinessStore: () => {
        return Api.get(`v1/business/my-business`);
      },
      getBusinessMembers: (businessId) => {
        return Api.get(`v1/business/${businessId}/members`);
      },
      addBusinessMember: (businessId, payload) => {
        return Api.post(`v1/business/${businessId}/members`, payload);
      },
      updateBusinessMember: (businessId, memberId, payload) => {
        return Api.put(`v1/business/${businessId}/members/${memberId}`, payload);
      },
      removeBusinessMember: (businessId, memberId) => {
        return Api.delete(`v1/business/${businessId}/members/${memberId}`);
      },
      
      // Business listing with pagination and search filters
      getBusinessList: (params = {}) => {
        const {
          page = 1,
          limit = 10,
          search = '',
          sort = 'id',
          sort_type = 'desc'
        } = params;
        
        const skip = (page - 1) * limit;
        let url = `v1/business?skip=${skip}&limit=${limit}&sort=${sort}&sort_type=${sort_type}`;
        
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        
        return Api.get(url);
      },
      
      // Store listing with pagination and search filters
      getStoreList: (params = {}) => {
        const {
          page = 1,
          limit = 10,
          search = '',
          sort = 'store_id',
          sort_type = 'desc'
        } = params;
        
        const skip = (page - 1) * limit;
        let url = `v1/store?skip=${skip}&limit=${limit}&sort=${sort}&sort_type=${sort_type}`;
        
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        
        return Api.get(url);
      },
      
      // Get businesses by category with pagination - DISABLED: business_category column does not exist
      // getBusinessesByCategory: (category, page = 1, limit = 10) => {
      //   const skip = (page - 1) * limit;
      //   return Api.get(`v1/business?skip=${skip}&limit=${limit}&category=${encodeURIComponent(category)}`);
      // },
      
      // Search businesses with pagination
      searchBusinesses: (searchTerm, page = 1, limit = 10) => {
        const skip = (page - 1) * limit;
        return Api.get(`v1/business?skip=${skip}&limit=${limit}&search=${encodeURIComponent(searchTerm)}`);
      },
      
      // Search stores with pagination
      searchStores: (searchTerm, page = 1, limit = 10) => {
        const skip = (page - 1) * limit;
        return Api.get(`v1/store?skip=${skip}&limit=${limit}&search=${encodeURIComponent(searchTerm)}`);
      },
      
      // Get featured businesses
      getFeaturedBusinesses: (page = 1, limit = 10) => {
        const skip = (page - 1) * limit;
        return Api.get(`v1/business?skip=${skip}&limit=${limit}&featured=true`);
      },
    };
